import { z } from 'zod';

/**
 * Contrats emails transactionnels & préférences (spec 06 §6).
 * Les tokens sont opaques : vérification = aléa hashé en base (TTL court),
 * désinscription = HMAC stateless. Aucun DTO n'expose de secret.
 */

const tokenField = z.string().trim().min(16).max(512);

export const EmailVerifyConfirmSchema = z.object({ token: tokenField }).strict();
export type EmailVerifyConfirmDto = z.infer<typeof EmailVerifyConfirmSchema>;

export const EmailUnsubscribeSchema = z.object({ token: tokenField }).strict();
export type EmailUnsubscribeDto = z.infer<typeof EmailUnsubscribeSchema>;

/**
 * Mise à jour des préférences (spec 06 §5.4, spec 10 §5) : opt-out global des
 * emails non essentiels et/ou opt-out des invitations à jouer — au moins une
 * des deux clés doit être présente.
 */
export const EmailPreferencesUpdateSchema = z
  .object({ optedOut: z.boolean().optional(), invitesOptedOut: z.boolean().optional() })
  .strict()
  .refine((v) => v.optedOut !== undefined || v.invitesOptedOut !== undefined, {
    message: 'au moins une préférence est requise',
  });
export type EmailPreferencesUpdateDto = z.infer<typeof EmailPreferencesUpdateSchema>;

/**
 * Préférences email du user connecté : opt-out global (emails non essentiels)
 * + opt-out des invitations à jouer (spec 10 §5 — l'opt-out global les
 * englobe : `optedOut=true` bloque aussi les invitations).
 */
export interface EmailPreferencesDto {
  optedOut: boolean;
  invitesOptedOut: boolean;
}
